'use client';

import CommentMore2424 from '@svg/sharing-trips/comment_more_24_24.svg';
import { useEffect, useRef, useState } from 'react';

export default function CommentMoreDropdownButton({ children }: { children: React.ReactNode }) {
  const moreRef = useRef<HTMLDivElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleOtherClick = (e: MouseEvent) => {
      if (moreRef.current?.contains(e.target as Node)) return;
      setIsDropdownOpen(false);
    };
    window.addEventListener('click', handleOtherClick);
    return () => window.removeEventListener('click', handleOtherClick);
  }, [isDropdownOpen]);

  return (
    <div className='relative' ref={moreRef}>
      <button className='shrink-0 flex items-center justify-center' onClick={() => setIsDropdownOpen(true)}>
        <CommentMore2424 />
      </button>
      <div
        className={`transition-all duration-150 ease-in-out
          ${isDropdownOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
        `}
        onClick={(e) => {
          e.stopPropagation();
          setIsDropdownOpen(false);
        }}
      >
        {children}
      </div>
    </div>
  );
}
